export default __webpack_public_path__ + "static/media/pv_composition1.81f318d7.jpg";